// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Anwesenheit, type ApiError } from "../../api";
import { useGetAnwesenheit as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export function useAnwesenheit(
  anwesenheitId: string,
  options: Omit<
    UseQueryOptions<Anwesenheit, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): Anwesenheit {
  const getter = useGetter();
  return useQuery(
    ["anwesenheiten", anwesenheitId],
    () => getter(anwesenheitId),
    options
  ).data!;
}
